import { render, staticRenderFns } from "./HistorialAtenciones.vue?vue&type=template&id=091c7b5c"
import script from "./HistorialAtenciones.vue?vue&type=script&lang=js"
export * from "./HistorialAtenciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports